import React, { CSSProperties } from 'react';
import { IStyle } from 'Styles';
import { InputProps } from '..';
import Input from '../input';

export interface Props extends InputProps {
  labeltext: string;
  labelStyle?: CSSProperties;
  containerStyle?: CSSProperties;
  labelClassname?: string;
  inputClassname?: string;
  containerClassname?: string;
  inputContainerClass?: string;
}

const FormInputRow = (props: Props) => {
  const {
    labeltext,
    labelStyle,
    containerStyle,
    required,
    labelClassname,
    inputClassname,
    containerClassname,
    inputContainerClass = 'w-[70%]',
    ...inputProps
  } = props;

  return (
    <div id='forminputrow-wrapper' style={{ ...styles.root, ...containerStyle }} className={containerClassname}>
      <label
        id={`forminputrow-wrapper-label-${labeltext}`}
        style={{ ...labelStyle, ...styles.labelContainer }}
        className={labelClassname}
        htmlFor={inputProps.id}
      >
        {labeltext}
        {required && <span style={styles.requiredLabel}>*</span>}
      </label>
      <div id={`forminputrow-container`} className={inputContainerClass}>
        <Input id={`forminputrow-input-${inputClassname}`} {...inputProps} className={inputClassname} />
      </div>
    </div>
  );
};

const styles: IStyle = {
  root: {
    flexDirection: 'row',
    display: 'flex',
    justifyContent: 'space-between',
  },
  labelContainer: {
    width: '30%',
  },
  inputContainer: {
    width: '70%',
  },
  input: {
    width: '100%',
  },
  errorMessage: {
    marginLeft: '1%',
    display: 'flex',
    width: '100%',
    color: 'red',
    fontSize: '0.9rem',
  },
  requiredLabel: {
    color: 'red',
    fontSize: '0.9rem',
  },
};

export default FormInputRow;
